import { load } from '@shopify/theme-sections';
import '../components/collection-slider';
import addTextColour from '../utils/addTextColour';

addTextColour('[data-static-hero-text]');

load('*');
